export function filterInt(value) {
    if (/^[-+]?(\d+)$/.test(value)) {
      return Number(value)
    } else {
      return NaN
    }
  }